import React, { useEffect, useRef } from 'react'
import { Box } from '@mui/material'

interface VimeoEmbedProps {
  embedCode: string
  title?: string
}

const VimeoEmbed: React.FC<VimeoEmbedProps> = ({ embedCode, title = 'Tutorial Video' }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Load Vimeo player script if not already loaded
    if (!window.Vimeo) {
      const script = document.createElement('script')
      script.src = 'https://player.vimeo.com/api/player.js'
      script.async = true
      document.head.appendChild(script)
    }
  }, [])

  return (
    <Box
      ref={containerRef}
      sx={{
        width: '100%',
        background: '#000',
        borderRadius: '8px',
        overflow: 'hidden',
        lineHeight: 0,
      }}
      dangerouslySetInnerHTML={{ __html: embedCode }}
    />
  )
}

export default VimeoEmbed
